<div class="pwReset-content">
    <span class="registrationHeader">{{'resetPassword' | translate}}</span>
    <dx-form class="resetPwForm" #resetForm [(formData)]="formData" labelLocation="top">
        <dxi-item dataField="password" [label]="{ text: 'newPassword' | translate}" [editorOptions]="{ mode: 'password' }"
            [colSpan]="2">
            <dxi-validation-rule type="required"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="configService.passwordPolicy.minLaenge"
                [message]="configService.passwordPolicy.minLaengeMessage"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="configService.passwordPolicy.minZiffern"
                [message]="configService.passwordPolicy.minZiffernMessage"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="configService.passwordPolicy.minKleinBuchstaben"
                [message]="configService.passwordPolicy.minKleinBuchstabenMessage"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="configService.passwordPolicy.minGrossBuchstaben"
                [message]="configService.passwordPolicy.minGrossBuchstabenMessage"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="configService.passwordPolicy.minSonderzeichen"
                [message]="configService.passwordPolicy.minSonderzeichenMessage"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="passwordConfirm" name="userPasswordConfirm" [label]="{text: 'repeatPassword' | translate}"
            [colSpan]="2" [editorOptions]="{ mode: 'password' }">
            <dxi-validation-rule type="required"></dxi-validation-rule>
            <dxi-validation-rule type="compare" [comparisonTarget]="passwordComparison.bind(this)"
                message="{{'wrongConfirmPassword' | translate}}"></dxi-validation-rule>
        </dxi-item>
        <dxi-item cssClass="psw-richtlinien-container" itemType="group" colCount="3" [template]="'pswRichtlinieTemplate'">
        </dxi-item>
        <div *dxTemplate="let data of 'pswRichtlinieTemplate'">
            <dxi-item colSpan="2">
              <span class="psw-richtlinien" [innerHTML] = 'configService.passwordPolicy.text'></span>
            </dxi-item>
        </div>
    </dx-form>
    
    <div class="resetFooter">
        <dx-button id="cancelButton" [disabled]="isSending" stylingMode="contained" type="default" (onClick)="onClickCancel($event)">
            <div *dxTemplate="let data of 'content'">
                <i class="dx-icon-remove button-icon"></i>
                <span class='dx-button-text' [innerHtml]="'cancel' | translate"></span>
            </div>
        </dx-button> 
        <dx-button id="resetSubmitButton" [disabled]="isSending" stylingMode="contained" type="default" (onClick)="onClickSave($event)">
            <div *dxTemplate="let data of 'content'">
                <div *ngIf="isSending === false">
                    <i class="dx-icon-startswith button-icon"></i>
                </div>
                <dx-load-indicator class='button-indicator' [visible]="isSending">
                </dx-load-indicator>
                <span class='dx-button-text' [innerHtml]="'save' | translate"></span>
            </div>
        </dx-button>       
    </div>
</div>